export const isMobile = () => {
  const spBreak = 767.98;
  return window.matchMedia('(max-width: ' + spBreak + 'px)').matches;
};
